import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';
import {
  usePaginatedQuery,
  type PaginatedFetchOptions,
  type RouteSort,
} from '~/hooks/usePaginatedQuery';

const FAILED_JOB_OUTBOX_ENTRIES_QUERY_KEY = 'failedJobOutboxEntries';

const failedJobOutboxEntriesQuery = graphql(`
  query FailedJobOutboxEntries($page: Int!, $size: Int!) {
    failedJobOutboxEntries(pageInput: { page: $page, size: $size }) {
      content {
        id
        payloadType
        payload
        lastError
        attempts
        failedAt
      }
      paging {
        number
        size
        totalElements
        totalPages
      }
    }
  }
`);

const retryFailedJobOutboxEntryMutation = graphql(`
  mutation RetryFailedJobOutboxEntry($id: ID!) {
    retryFailedJobOutboxEntry(id: $id) {
      id
    }
  }
`);

const useFailedJobOutboxEntries = (
  page: number,
  pageSize: number,
  _filters?: unknown,
  _sort?: RouteSort,
  options?: PaginatedFetchOptions
) =>
  useGraphqlQuery(
    failedJobOutboxEntriesQuery,
    [FAILED_JOB_OUTBOX_ENTRIES_QUERY_KEY, String(page), String(pageSize)],
    { page, size: pageSize },
    options
  );

const EMPTY_PAGING = { number: 0, size: 0, totalElements: 0, totalPages: 0 };

export const useFailedJobOutboxEntriesPaginated = (pageSize: number) => {
  const result = usePaginatedQuery({
    fetchHook: useFailedJobOutboxEntries,
    select: (data) => data?.failedJobOutboxEntries,
    options: { pageSize },
  });

  return { ...result, pagination: result.pagination ?? EMPTY_PAGING };
};

export const useRetryFailedJobOutboxEntry = () =>
  useGraphqlMutation(retryFailedJobOutboxEntryMutation, [
    FAILED_JOB_OUTBOX_ENTRIES_QUERY_KEY,
  ]);
